module.exports = __webpack_public_path__ + "static/background-image-single-f949936162b03d083dbc2072a65878fa.jpg";